export default function PillToggle({ options, active, onChange, onDark = false }) {
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {options.map(opt => {
        const isActive = active === opt.key
        const inactiveBorder = onDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'
        const inactiveColor = onDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)'
        const activeBg = onDark ? 'var(--bone)' : 'var(--pitch)'
        const activeColor = onDark ? 'var(--pitch)' : 'var(--bone)'
        const activeBorder = onDark ? 'var(--bone)' : 'var(--pitch)'

        return (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            className="pill-toggle-btn"
            style={{
              fontFamily: 'var(--f-b)', fontSize: 12, fontWeight: 500,
              padding: '8px 16px', borderRadius: 20, cursor: 'pointer',
              border: `1px solid ${isActive ? activeBorder : inactiveBorder}`,
              background: isActive ? activeBg : 'transparent',
              color: isActive ? activeColor : inactiveColor,
            }}>
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
